import { SpeedKind } from '../Constant';
//
export type NAME_DEV_SET = {
  //機器 INDEX を取得または設定します。機器INDEX 1~384
  DEV_INDEX: number;
  //実装を取得または設定します。
  EST: number;
  //機器番号を取得または設定します。
  DEV_NO: string;
  //機器名称を取得または設定します。
  DEV_NAME: string;
  //電動機フラグを取得または設定します。
  FLG_MOTOR: number;
  //電流値補正乗数を取得または設定します。
  REV_VAL: number;
  // 定格電流 (A) を取得または設定します。
  RATED_CUR: number;
  //ベアリング呼び番号 (負荷側) を取得または設定します。
  BEARING_LD: string;
  //ベアリング呼び番号 (反負荷側) を取得または設定します。
  BEARING_ANTI_LD: string;
  //定格回転数 (min-1) を取得または設定します。
  RATED_SPEED: number;
  //定格出力 (kW) を取得または設定します。
  RATED_POWER: number;
  //Pole 数を取得または設定します。
  POLE: number;
  //電圧 (V) を取得または設定します。
  VOLTAGE: number;
  //電源周波数 (Hz) を取得または設定します。
  PWR_FREQ: number;
  //励磁電流 (A) を取得または設定します。
  EXC_CUR: number;
  //インバータキャリア周波数 (Hz) を取得または設定します。
  INV_FREQ: number;
  //裕度 (%) を取得または設定します。
  WEALTH: number;
  //起動判定電流閾値 (A) を取得または設定します。
  START_JDG_CUR: number;
  //備考を取得または設定します。
  NOTE: string;
  //キャリア周波数マスクを取得または設定します。
  CAREER_MASK: number;
  // 波形生成を取得または設定します。
  WAV_MAKE: number;
  //インバータ駆動を取得または設定します。
  INV_DRV_ON: number;
  //EMC 識別を取得または設定します。
  EMC_TYPE: number;
  //平滑化窓幅w0
  SMOOTH_W0: (number | null);
  //平滑化短い窓幅w1
  SMOOTH_W1: (number | null);
  //平滑化長い窓幅w2
  SMOOTH_W2: (number | null);
  //閾値xσ
  TH_SIGMA: (number | null);
  //軽故障閾値R相
  TH_L_R: (number | null);
  //軽故障閾値S相
  TH_L_S: (number | null);
  //軽故障閾値T相
  TH_L_T: (number | null);
  //重故障閾値R相
  TH_H_R: (number | null);
  //重故障閾値S相
  TH_H_S: (number | null);
  //重故障閾値T相
  TH_H_T: (number | null);
  //振動(速度)上限周波数
  SPD_UP_FREQ: (number | null);
  //振動(速度)下限周波数
  SPD_LO_FREQ: (number | null);
  //振動(変位)上限周波数
  DSP_UP_FREQ: (number | null);
  //振動(変位)下限周波数
  DSP_LO_FREQ: (number | null);
  //起動判定電流閾値 (A)を(%)に変換した値
  startJdgCurPer: number;
};

/** レスポンス情報 */
export type ResponceDataType = {
  ResponseCode: number;
  ErrorCode: number;
  ResponseMessage: string;
  ErrorMessage: string;
};

/**
 * EMC設定画面で使用する機器番号・機器名称情報取得
 * @returns
 */
export const GetNameDevSetEMCList = (): Promise<NAME_DEV_SET[]> => {
  return new Promise((resolve, reject) => {
    fetch("api/NameDevSet/q?filter=EST eq 1 and EMC_TYPE eq 1")
      .then((res) => {
        if (!res.ok) {
          let message = `データが見つかりませんでした status:${res.status}`;
          reject(new Error(message));
        }
        else {
          return res.json();
        }
      })
      .then((result: NAME_DEV_SET[]) => {
        if (NameDevSetListValidate(result)) {
          result.forEach((dev) => {
            //起動判定電流閾値 (%) に変換
            dev.START_JDG_CUR = dev.RATED_CUR != 0 ? Math.round((dev.START_JDG_CUR / dev.RATED_CUR) * 100) : 0;
          });
          resolve(result);
        }
        else {
          reject('Invalidate response');
        }
      })
      .catch((error) => {
        console.log(error);
        reject(error);
      })
  });
};


/**
 * EST=1（実装）だけの機器番号・名称リスト取得
 * @returns
 */
export const GetNameDevSetListByDevIndex = (devIndex: string): Promise<NAME_DEV_SET[]> => {
  return new Promise((resolve, reject) => {
    fetch(`api/NameDevSet/q?filter=DEV_INDEX eq ${devIndex}`)
      .then((res) => res.json())
      .then((result: NAME_DEV_SET[]) => {
        //console.debug(["api/NameDevSet", result]);
        if (NameDevSetListValidate(result)) {
          result.forEach((dev) => {
            dev.START_JDG_CUR = dev.RATED_CUR != 0 ? Math.round((dev.START_JDG_CUR / dev.RATED_CUR) * 100) : 0;
          });
          resolve(result);
        }

        reject('Invalidate response');
      },
        (error) => {
          console.log(error);
          reject(error);
        }
      );
  });
};

/**
 * EST=1（実装）だけの機器番号・名称リスト取得
 * @returns
 */
export const GetNameDevSetListByEst1 = (): Promise<NAME_DEV_SET[]> => {
  return new Promise((resolve, reject) => {
    fetch("api/NameDevSet/q?filter=EST eq 1")
      .then((res) => res.json())
      .then((result: NAME_DEV_SET[]) => {
        //console.debug(["api/NameDevSet", result]);
        if (NameDevSetListValidate(result)) {
          result.forEach((dev) => {
            dev.START_JDG_CUR = dev.RATED_CUR != 0 ? Math.round((dev.START_JDG_CUR / dev.RATED_CUR) * 100) : 0;
          });
          resolve(result);
        }

        reject('Invalidate response');
      },
        (error) => {
          console.log(error);
          reject(error);
        }
      );
  });
};

//デバイス名称一覧を取得
export const GetNameDevSetList = (): Promise<NAME_DEV_SET[]> => {
  return new Promise((resolve, reject) => {
    fetch("api/NameDevSet")
      .then((res) => res.json())
      .then((result: NAME_DEV_SET[]) => {
        console.debug(["api/NameDevSet", result]);
        if (NameDevSetListValidate(result)) {
          result.forEach((dev) => {
            //起動判定電流閾値 (%) に変換
            dev.startJdgCurPer = dev.RATED_CUR != 0 ? Math.round((dev.START_JDG_CUR / dev.RATED_CUR) * 100) : 0;
          });
          resolve(result);
        }
        else {
          reject('Invalidate response');
        }
      }).catch((error) => {
        console.log(error);
        reject(error);
      })
  });
};

//グループ一覧取得データ検証
const NameDevSetListValidate = (data: NAME_DEV_SET[]): boolean => {
  if (data == undefined) {
    console.debug(`GetNameDevSetList NG `);
    return false;
  }
  console.debug(`GetNameDevSetList OK `);
  return true;
};

export const SetNameDevSetList = (list: NAME_DEV_SET[]): Promise<number> => {
  //console.debug(['SetNameDevSetList()', list]);
  return new Promise((resolve, reject) => {
    //起動判定電流閾値 (%) を元に戻す
    //console.debug(`devList check 1st:`, list)
    list.forEach((dev) => { dev.START_JDG_CUR = dev.RATED_CUR * (dev.startJdgCurPer / 100) });
    //console.debug(`devList check 2nd:`, list)
    fetch("api/NameDevSet", {
      method: 'put',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(list),
    })
      .then((res) => resolve(res.status))
      .catch(reason => reject(reason));
  });
}

/**
 * 選択した機器番号の行のデータを取得
 * @param devIndex 
 * @returns 
 */
export const GetNameDevSetRow = (devIndex: number): Promise<NAME_DEV_SET> => {
  return new Promise((resolve, reject) => {
    const url = 'api/NameDevSet'.concat(`/${devIndex}`)
    console.debug(['GetNameDevSetRow url', url])
    fetch(url)
      .then((res) => res.json())
      .then((result: NAME_DEV_SET) => resolve(result))
      .catch((error) => {
        console.log(error);
        reject(error);
      })
  });
}

/**
 * NAME_DEV_SETテーブルから1行データを更新する
 * @param devSet 
 * @returns 
 */
export const SetNameDevSetRow = (devSet: NAME_DEV_SET): Promise<ResponceDataType> => {
  console.debug(['SetNameDevSetRow check', devSet])
  return new Promise((resolve, reject) => {

    fetch("api/NameDevSet/devSetRow", {
      method: 'put',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(devSet),
    })
      .then((res) => res.json())
      .then((result: ResponceDataType) => resolve(result))
      .catch(reason => reject(reason));

  });
}


/**
 *  FFT 比較として有効かを取得します。
 */
export const IsValidKindOfFftCmp = (speed: number, measure: number): boolean => {
  return speed === SpeedKind.SPEED_KIND_HIGHT || speed === SpeedKind.SPEED_KIND_CALC ? true : false;
};

/**
 *  コナンエアとして有効かを取得します。
 */
export const IsValidKindOfFftCmpConan = (speed: number, measure: number): boolean => {
  return speed === SpeedKind.SPEED_CONAN ? true : false;
};
